// Справочник по API: https://www.wix.com/velo/reference/api-overview/introduction
// Пример «Hello, World!»: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
$w("#readMoreButton1").onClick(() => {
$w("#readMoreStatebox1").changeState("expandedState2");
});

$w("#readLessButton1").onClick(() => {
$w("#readMoreStatebox1").changeState("collapsedState1");
});
});